<div class="d-flex">
  <app-mobile-header-main (titleClicked)="openTaxonomyMenu = $event" mainTitle="{{ currentMember?.user?.name }}" menulink="/menu/documentos"></app-mobile-header-main>
  <div class="taxonomy-overlay" [class.taxonomy-overlay-active]="openTaxonomyMenu" (click)="openTaxonomyMenu = false"></div>
  @if (urlParamsService.params.sidebar) {
    <app-taxonomy [mainTitle]="'documents.documents' | translate" allowSearch [(isSearchOpen)]="isSearchOpen" (isSearchOpenChange)="toggleSearch($event)" [class.isMenuMobileOpen]="openTaxonomyMenu">
      <app-documents-taxonomy [isSearchOpen]="isSearchOpen" [listPath]="'member'" [disableMainButton]="!isMemberCurrentUser" (sortingChange)="loadDocuments({ page: 1, search: searchQuery })">
      </app-documents-taxonomy>
    </app-taxonomy>
  }
</div>

<div class="d-flex flex-column w-100">
  @if (isSearchOpen) {
    <app-documents-search
      [(search)]="searchQuery"
      [selectedMemberOrGroup]="currentMember ? { id: currentMember.user.id, name: currentMember.user.name, type: 'member' } : null"
      (searchChange)="loadDocuments({ page: 1, search: $event })"
      (closeClick)="isSearchOpen = false; toggleSearch(isSearchOpen)"
      @slideDownUpTrigger
    ></app-documents-search>
  }

  <div class="documents">
    <app-electron-deprecation-warning></app-electron-deprecation-warning>

    <div class="documents__header">
      @if ((isSearchOpen && searchQuery) || mobileSearch) {
        <h2 class="documents__title">{{ 'documents.searchResults' | translate }}</h2>
      } @else if (currentMember) {
        <h2 class="documents__title">{{ currentMember.user?.name }}&nbsp;</h2>
      }
      <app-search [(query)]="mobileSearch" (queryChange)="pageNumber = 1; loadDocuments({ page: 1, search: { search: $event } })"></app-search>
      @if (isSearchOpen && searchQuery && this.documents?.length > 0) {
        <button type="button" class="btn-text btn-M icon-start ml-2" [disabled]="isLoading" (click)="exportDocuments(searchQuery)">
          <i class="far fa-file-csv"></i>
          {{ 'documents.export' | translate }}
        </button>
      }
    </div>

    @if (currentUser && !searchQuery && !mobileSearch && !appService.documentStatusFilter && documents?.length === 0) {
      <div class="documents-empty">
        <img src="/assets/alerts/confirmation-2.svg" alt="" />
        <p class="documents-empty__title">{{ 'documents.noDocumentsHere' | translate }}</p>

        @if (urlParamsService.params.folderBreadCrumbs) {
          <button type="button" routerLink="/pastas" class="btn-M btn-filled-cancel">{{ 'button.accessFolders' | translate }}</button>
        }
        @if (currentUser?.currentPermissions.create_documents) {
          <button type="button" (click)="routeToNewDocument()" class="btn-M btn-filled">
            {{ 'documents.createADocument' | translate }}
          </button>
        }
      </div>
    } @else if (currentUser && !isLoading && documents && (searchQuery || mobileSearch || appService.documentStatusFilter) && documents?.length === 0) {
      <div class="documents-filtered-empty">
        <div class="documents-filtered-empty_title">{{ 'settings.nothingHere' | translate }}</div>
        <div class="documents-filtered-empty_text">
          <span>{{ 'documents.noDocumentsMatchingFilter' | translate }}</span>
        </div>
        <button type="button" class="default-button" (click)="clearFilters()">{{ 'documents.clearFilters' | translate }}</button>
      </div>
    }

    @if (appService.listFormat === ListFormat.Box) {
      <app-documents-list-boxes
        [currentUser]="currentUser"
        [documents]="documents"
        [currentOrganizationMemberId]="route.snapshot.params.memberId"
        [hidePagination]="isLoading || isLastPage || pageNumber > 99"
        (loadPageClick)="loadDocuments({ page: pageNumber + 1, search: searchQuery })"
        (signClick)="sign($event)"
        (folderClick)="openFoldersModal({ documents: $event })"
        (deleteClick)="delete($event)"
        (transferClick)="transfer($event)"
        (toggleBlockClick)="toggleBlock($event)"
        (resendWebhookClick)="resendWebhook($event)"
      >
      </app-documents-list-boxes>
    }

    @if (appService.listFormat === ListFormat.List) {
      <app-documents-list-table
        [currentUser]="currentUser"
        [hidePagination]="isLoading || isLastPage || pageNumber > 99"
        (loadPageClick)="loadDocuments({ page: pageNumber + 1, search: searchQuery })"
        (sortingChange)="loadDocuments({ page: 1, search: searchQuery })"
        [documents]="documents"
        (signClick)="sign($event)"
        (folderClick)="openFoldersModal({ documents: $event })"
        (deleteClick)="delete($event)"
        (transferClick)="transfer($event)"
        (toggleBlockClick)="toggleBlock($event)"
        (resendSignaturesClick)="resendSignatures($event)"
        (resendWebhookClick)="resendWebhook($event)"
      >
      </app-documents-list-table>
    }
  </div>
</div>
